<template>
  <div class="popupFloating" :class="isLightMode ? 'light' : 'dark'">
    <button type="button" class="close" @click="onClickClose"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.267814 0.258983C0.621422 -0.0897475 1.19078 -0.0857936 1.53951 0.267814L5.96901 4.75926L10.4649 0.263383C10.8161 -0.0877943 11.3854 -0.0877943 11.7366 0.263383C12.0878 0.614561 12.0878 1.18393 11.7366 1.53511L7.24074 6.03099L11.7322 10.4605C12.0858 10.8092 12.0897 11.3786 11.741 11.7322C11.3923 12.0858 10.8229 12.0897 10.4693 11.741L5.96898 7.30275L1.53511 11.7366C1.18393 12.0878 0.614561 12.0878 0.263383 11.7366C-0.0877943 11.3854 -0.0877943 10.8161 0.263383 10.4649L4.69725 6.03102L0.258983 1.53068C-0.0897475 1.17707 -0.0857936 0.607714 0.267814 0.258983Z" fill="white" fill-opacity="0.6"/>
    </svg></button>
    <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
      <path d="M0 4.62459C0 6.19269 0.0797342 7.41528 0.239202 8.29236C0.425249 9.19601 0.757475 9.91362 1.23588 10.4452C1.74086 11.0033 2.49834 11.402 3.50831 11.6412C4.51827 11.8804 5.87375 12 7.57475 12V9.24917C6.35216 9.24917 5.55482 9.06312 5.18272 8.69103C4.99668 8.50499 4.86379 8.2392 4.78405 7.89369C4.7309 7.57475 4.70432 7.1495 4.70432 6.61794V6.09967H7.57475V0H0V4.62459ZM9.76744 4.62459C9.76744 6.19269 9.84717 7.41528 10.0066 8.29236C10.1927 9.19601 10.5249 9.91362 11.0033 10.4452C11.5083 11.0033 12.2658 11.402 13.2757 11.6412C14.2857 11.8804 15.6412 12 17.3422 12V9.24917C16.1196 9.24917 15.3223 9.06312 14.9502 8.69103C14.7641 8.50499 14.6312 8.2392 14.5515 7.89369C14.4983 7.57475 14.4718 7.1495 14.4718 6.61794V6.09967H17.3422V0H9.76744V4.62459Z" fill="#0F577A"/>
    </svg></div>
    <div class="infoArea">
      <h3>{{ t('skillMonitor-main-sample-title') }}</h3>
      <p>{{ t('skillMonitor-main-sample-description') }}</p>
      <div class="btnArea flex">
        <button type="button" class="btn" @click.stop="onDoNotShowAgain">
          {{ t('skillMonitor-main-sample-do-not-again') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getCookie, setCookie} from '~~/package/utils/CookieUtil';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from '#imports';
import {CookieKeyType} from '~~/package/mapper/common/model/CookieKeyType';

const { t } = useI18n();

const dialogStore = useDialogStore();

onMounted(() => {
  if (getCookie(CookieKeyType.DO_NOT_SHOW_SAMPLE_POPUP)) {
    onClickClose();
  }
})

const isLightMode = computed(() => {
  return dialogStore.options?.props?.isLightMode ?? false;
})

const onClickClose = () => {
  dialogStore.close()
}

const onDoNotShowAgain = () => {
  const date = new Date();
  setCookie(CookieKeyType.DO_NOT_SHOW_SAMPLE_POPUP, "true", { expires: new Date(date.setDate(date.getDate() + 365)) });
  dialogStore.close();
}
</script>

